// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3bPws","bigColWidth":"Table_bigColWidth__2xleQ","biggerColWidth":"Table_biggerColWidth__3Lamy","row":"Table_row__20m9v","col":"Table_col__35jXt"};